import { useQuery } from "@tanstack/react-query";
import { useSubscription } from "store/auth/auth-store";
import apiInputService from "services/apiInputService";
import { ActivityItemStats } from "./dashboard";

const fetchDashboardActivityItemStats = async (): Promise<
  Array<ActivityItemStats>
> => {
  const response = await apiInputService.get(
    "/frontend/dashboard/activityItemStats"
  );

  return response?.data;
};

export const useDashboardActivityItemStats = (options?: any) => {
  const { subscription } = useSubscription();

  return useQuery(
    ["dashboard", "stats", "activityItem", subscription],
    () => fetchDashboardActivityItemStats(),
    {
      ...options,
      enabled: !!subscription,
      staleTime: 0,
    }
  );
};
